const maintenanceEnabled = ref(false)
const skipMaintenance = ref(false)

export { maintenanceEnabled, skipMaintenance }
